import React, { useState, useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

export function ProcessingAnimation() {
    const { t } = useTranslation();
    const [currentPhrase, setCurrentPhrase] = useState(0);
    const [progress, setProgress] = useState(0);

    const processingPhrases = [
        "🔍 Scanning your document...",
        "🧪 Analyzing lab values...",
        "📚 Understanding medical terms...",
        "📊 Preparing insights...",
        "✨ Adding helpful explanations...",
        "📋 Compiling your findings...",
        "📝 Generating your report...",
    ];

    useEffect(() => {
        // Cycle through phrases
        const phraseInterval = setInterval(() => {
            setCurrentPhrase(prev => (prev + 1) % processingPhrases.length);
        }, 2000);

        // Animate progress
        const progressInterval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 90) {
                    // Slow down near the end
                    return prev + (95 - prev) * 0.1;
                }
                return prev + (1 + Math.random() * 2);
            });
        }, 100);

        return () => {
            clearInterval(phraseInterval);
            clearInterval(progressInterval);
        };
    }, []);

    return (
        <div className="w-full px-2">
            <div className="relative">
                <div className="text-center mb-2 text-sm font-medium text-indigo-600">
                    {processingPhrases[currentPhrase]}
                </div>
                <div className="overflow-hidden h-3 mb-2 text-xs flex rounded-full bg-indigo-50">
                    <div
                        style={{ width: `${progress}%` }}
                        className="animate-pulse shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-indigo-500 transition-all duration-500 ease-out"
                    />
                </div>
            </div>
        </div>
    );
} 